const generalConfig = {
  generalConfig: {
    adminConfigsForDeveloping:false,
    showPlayerTypes: ['videojs-player'], //, 'audio-player'
    addCustomNameAfterLogo: 'TAU MAM',
    customNameHrefTo: 'https://taumam.mtva.hu/tau/api/',
    playerName: 'MTVA Médialejátszó'
  }
};
export default generalConfig;
